export const TID = {
  // Auth
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginSubmit: "login-submit",
  signupEmail: "signup-email",
  signupPassword: "signup-password",
  signupName: "signup-name",
  signupSubmit: "signup-submit",
  logoutBtn: "logout-btn",
  // Header
  langSwitcher: "lang-switcher",
  currencySwitcher: "currency-switcher",
  themeToggle: "theme-toggle",
  // Nav
  navDashboard: "nav-dashboard",
  navTransactions: "nav-transactions",
  navAdd: "nav-add",
  navBudgets: "nav-budgets",
  navAccount: "nav-account",
  navAdmin: "nav-admin",
  // Add
  micButton: "voice-record-btn",
  photoInput: "photo-input",
  photoButton: "photo-btn",
  manualForm: "manual-form",
  manualAmount: "manual-amount",
  manualCurrency: "manual-currency",
  manualCategory: "manual-category",
  manualDescription: "manual-description",
  manualDate: "manual-date",
  manualType: "manual-type",
  manualSubmit: "manual-submit",
  overrideBudget: "override-budget-btn",
  // Installments
  navInstallments: "nav-installments",
  installmentsRoot: "installments-root",
  installmentNewBtn: "installment-new-btn",
  installmentName: "installment-name",
  installmentAmount: "installment-amount",
  installmentTotal: "installment-total",
  installmentDay: "installment-day",
  installmentStart: "installment-start",
  installmentSubmit: "installment-submit",
  installmentCard: "installment-card",
  installmentPayBtn: "installment-pay-btn",
  installmentDeleteBtn: "installment-delete-btn",
  // Dashboard
  dashboardRoot: "dashboard-root",
  statThisMonth: "stat-this-month",
  statLastMonth: "stat-last-month",
  // Admin
  adminRoot: "admin-root",
  adminProductsTable: "admin-products-table",
  adminRegionsTable: "admin-regions-table",
  adminUserStats: "admin-user-stats",
  adminSystem: "admin-system",
  adminSystemRefresh: "admin-system-refresh",
  // Profile
  deleteAccountBtn: "delete-account-btn",
  accountAdminLink: "account-admin-link",
  accountRoot: "account-root",
};
